import type ServiceContainer from 'services/service-container';

class BaseService {
  constructor(public service: ServiceContainer) {
    this.service = service;
  }
}

export default BaseService;
